import styled, { css } from 'styled-components'

export const Text = styled.span<{
  $value: number
}>`
  ${({ $value }) =>
    $value > 0 &&
    css`
      color: var(--text-success);
    `}

  ${({ $value }) =>
    $value < 0 &&
    css`
      color: var(--text-critical);
    `}
`
